import { createApp } from 'vue';
import Login from '@componentPath/login/Login';
import MemberBtn from "@componentPath/header/MemberBtn";
import store from '@storePath';

const app = createApp(Login);

app.use(store);
app.mount('#vue_login');


const header = createApp(MemberBtn);

header.use(store);
header.mount('#header_btns_wrapper');

import ConfirmDialogue from '@componentPath/modal/ConfirmDialogue';

const popup = createApp({
    name: "VueGlobalMsgModal",
    template: `<confirm-dialogue></confirm-dialogue>`,
    components: {
        ConfirmDialogue
    },
});
popup.mount('#vue_popup_msg');

/*import { createApp } from 'vue'
import LoginApp from '@componentPath/login/LoginApp'
import Login from '@componentPath/login/Login'
import store from '@storePath'

const app = createApp(LoginApp)

app.use(store)

app.mount('#vue-login')

import {ref, createApp, onMounted, reactive, computed} from 'vue'
import store from '@storePath';
import Login from "@componentPath/login/Login";

const app = createApp({
    template: `<a href="javascript: void(0);" @click="isModalOpen = true" id="go_login" class="header_member_btn active">登入</a>
    <login v-if="isModalOpen" :is-show="isModalOpen" v-model:isOpen="isModalOpen"></login>
    `,
    components: {
        Login
    },
    setup() {
        const isModalOpen = ref(false);

        return {
            isModalOpen
        }
    },
});

app.use(store);
app.mount('#vue-login')
 */